"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SDKHeaders = void 0;
// eslint-disable-next-line @typescript-eslint/ban-types
const getVersionConfig = (version, withCredentials = true, params = {}) => {
    return Object.assign(Object.assign({}, params), { headers: { 'If-Match': version }, withCredentials: withCredentials === null || withCredentials ? true : false });
};
exports.SDKHeaders = {
    getVersionConfig,
};
//# sourceMappingURL=sdkHeaders.js.map